export const Retry = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fill="#55565C"
        fillRule="evenodd"
        d="M3.2 8.178a7.039 7.039 0 0 1 11.777-3.157l1.786 1.786h-2.987a.704.704 0 0 0 0 1.408h4.685a.704.704 0 0 0 .704-.704V2.826a.704.704 0 0 0-1.408 0v2.985l-1.783-1.784A8.446 8.446 0 0 0 1.841 7.813a.704.704 0 0 0 1.36.365Zm14.462 3.146a.704.704 0 0 0-.863.498 7.04 7.04 0 0 1-11.776 3.157l-1.785-1.786h2.987a.704.704 0 0 0 0-1.408H1.539a.704.704 0 0 0-.704.704v4.685a.704.704 0 0 0 1.408 0V14.19l1.783 1.783a8.447 8.447 0 0 0 14.133-3.787.704.704 0 0 0-.497-.862Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
